import api from "../axios/axiosConfig";

export const getRecharge = async () => {
    try {
        const response = await api.get(`/UserActiveTransactions`);
        return response.data;
    } catch (error) {
        //console.error('Erro ao buscar recargas ativas', error);
        throw error;
    }
};

export const getConnectorStatus = async (chargerId: string, connectorId: number) => {
    try {
        const response = await api.get(`/OnlineConnectorStatus/${chargerId}/${connectorId}`);
        return response.data;
    } catch (error) {
        //console.error('Erro ao buscar as informações do connector ativo', error);
        throw error;
    }
};